import { WorkflowTypes } from '../NewWorkflow/newWorkflowReducer';

export enum AppPageKind {
  FORM_BUILDER,
  LANDING,
  NEW_WORKFLOW,
  DUPLICATE_WORKFLOW
}

export interface AppState {
  workflowId: string;
  workflowName: string;
  workflowType: WorkflowTypes;
  role: string | null;
  page: AppPageKind;
}

export interface DuplicateWorkflow {
  workflowId: string;
  workflowName: string;
  workflowType: WorkflowTypes;
}

export interface BuildWorkflow {
  workflowId: string;
  page: AppPageKind;
}

export enum AppActionKind {
  SET_APPCONTEXT,
  SET_APPPAGE,
  UPDATE_WORKFLOWID,
  BUILD_WORKFLOW,
  SET_DUPLICATE_WORKFLOW
}

export interface AppAction {
  type: AppActionKind;
  payload?: string | AppPageKind | BuildWorkflow | DuplicateWorkflow;
}
